import { createElement, memo } from '@max/max';
import { CouponStatus, BIZ_MAP } from '../../constants';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LinearGradient from '@hfe/max-linear-gradient';
import { useCountdown } from '../../hooks/useCountdown';
import { isIOS } from '../../utils/common-utils';
const isWeb = true;
import './index.scss';
function Coupon(props) {
    const { width, height, isSingle, couponData, singleCouponShowTag, onClick } = props;
    const countdownText = useCountdown(couponData.expireTime);
    const formatPersonaDesc = (name, isSingle) => {
        if (!name)
            return '';
        const maxLength = isSingle ? 4 : 6;
        if (name.length > maxLength) {
            return name.substring(0, maxLength - 1) + '...';
        }
        return name;
    };
    const formatPrizeName = (name) => {
        if (!name)
            return '';
        const maxLength = 10;
        if (name.length > maxLength) {
            return name.substring(0, 9) + '...';
        }
        return name;
    };
    const getDesc = (couponData) => {
        if (couponData.prizeDesc)
            return couponData.prizeDesc;
        if (couponData.amountType === 2) {
            return `最高减${Math.floor(Number(couponData.maxDiscountAmount) / 100)}`;
        }
        return couponData.requireAmount || '无门槛';
    };
    const getExpireTimeText = () => {
        if (!couponData.expireTime || couponData.expireTime <= 0) {
            return '疯抢中';
        }
        const now = Date.now();
        const diffMs = couponData.expireTime - now;
        if (diffMs <= 0) {
            return '';
        }
        const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000));
        if (diffDays > 6) {
            const expireDate = new Date(couponData.expireTime);
            const month = String(expireDate.getMonth() + 1).padStart(2, '0');
            const date = String(expireDate.getDate()).padStart(2, '0');
            return `${month}/${date}到期`;
        }
        if (diffDays > 0) {
            return `${diffDays}天后到期`;
        }
        return countdownText;
    };
    const getBtnText = (status) => {
        switch (status) {
            case CouponStatus.NotClaimed:
                return '立即抢券';
            case CouponStatus.InVaild:
                if (couponData.cannotDrawCode === 120001) {
                    return '已抢光';
                }
                else {
                    return '立即抢券';
                }
            case CouponStatus.ToUse:
                return '去使用';
            case CouponStatus.Used:
                return '已使用';
            case CouponStatus.Expired:
                return '已过期';
            case CouponStatus.Already:
                return '去使用';
            case CouponStatus.Claimed:
                return '去使用';
            default:
                return '';
        }
    };
    const processAmount = (couponData) => {
        if (couponData.amountType === 1) {
            return Math.floor(Number(couponData.amount) / 100);
        }
        else {
            return Number(couponData.amount) / 10;
        }
    };
    const leftBizStyle = {
        borderTopLeftRadius: '16rpx',
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: '16rpx'
    };
    const centerBizStyle = {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: '12rpx',
        borderBottomRightRadius: '12rpx'
    };
    const columnContentStyle = {
        marginTop: '52rpx',
        height: '87rpx',
        flexDirection: 'column'
    };
    const rowContentStyle = {
        marginLeft: '26rpx',
        flexDirection: 'row',
        height: '72rpx'
    };
    const btnText = getBtnText(couponData.prizeStatus);
    const btnTextColor = btnText === '立即抢券' ? '#FFFFFF' : btnText === '去使用' ? '#FF4B10' : btnText === '已使用' ? '#888888' : '#C2C2C2';
    const otherTextColor = btnText === '已过期' || btnText === '已抢光' ? {
        color: '#C2C2C2'
    } : {};
    return <View className="container" onClick={onClick} style={{
            width,
            height,
            flexDirection: isSingle ? 'row' : 'column',
            justifyContent: isSingle ? 'space-between' : 'flex-start'
        }}>
      <View x-if={!isSingle || singleCouponShowTag} className="bizLineContainer" style={{
            width,
            justifyContent: isSingle ? 'flex-start' : 'center'
        }}>
        <View className="bizLineBg" style={{
            ...(isSingle ? leftBizStyle : centerBizStyle),
            ...(btnText === '已过期' || btnText === '已抢光' ? {
                backgroundColor: '#F0F0F0'
            } : {})
        }}>
          <Text className="bizLineText" numberOfLines={1} style={otherTextColor}>
            {couponData.personaDesc ? formatPersonaDesc(couponData.personaDesc, isSingle) : BIZ_MAP[couponData.bizLine]}
          </Text>
        </View>
      </View>
      <View className="contentContainer" style={{
            ...(isSingle ? rowContentStyle : columnContentStyle)
        }}>
        <View className="amoutContainer" style={isSingle ? {
            marginRight: '26rpx',
            height: '100rpx'
        } : {}}>
          <View className="amoutContainerTop">
            <Text x-if={couponData.amountType === 1} className="amoutLeft" style={otherTextColor}>¥</Text>
            <Text className="amout" style={{
            ...otherTextColor,
            ...(isWeb ? {
                marginBottom: '-6rpx'
            } : !isIOS() ? {
                marginBottom: '-8rpx'
            } : {})
        }}>{processAmount(couponData)}</Text>
            <Text x-if={couponData.amountType === 2} className="amoutRight" style={otherTextColor}>折</Text>
          </View>
          <View x-if={isSingle} className="amoutContainerBottom">
            <Text className="couponDesc" numberOfLines={1} style={otherTextColor}>
              {getDesc(couponData)}
            </Text>
          </View>
        </View>
        <View className="descContainer">
          <Text x-if={isSingle} className="couponTitle" numberOfLines={1} style={otherTextColor}>
            {formatPrizeName(couponData.prizeName)}
          </Text>
          <Text x-if={isSingle} className="couponDesc">
            {getExpireTimeText()}
          </Text>
          <Text x-else className="couponDesc" numberOfLines={1} style={otherTextColor}>
            {getDesc(couponData)}
          </Text>
        </View>
      </View>
      <View className="btnContainer" style={isSingle ? {
            marginRight: '26rpx'
        } : {
            marginTop: '12rpx',
            justifyContent: 'flex-start'
        }}>
        <LinearGradient x-if={btnText !== '去使用'} className="btn" start={{
            x: 0.12,
            y: 0.18
        }} end={{
            x: 0.88,
            y: 0.82
        }} colors={btnText === '立即抢券' ? ['#FF7F2F', '#FF2D19'] : ['#FFFFFF', '#FFFFFF']}>
          <Text className="btnText" style={{
            color: btnTextColor
        }}>
            {btnText}
          </Text>
        </LinearGradient>
        <View x-else className="btn" style={{
            borderWidth: '1rpx',
            borderColor: '#FF4B10'
        }}>
          <Text className="btnText" style={{
            color: btnTextColor
        }}>
            {btnText}
          </Text>
        </View>
        {!isSingle && <View>
          <View x-if={btnText === '立即抢券'} className="processContainer">
            <View className="processBg">
              <View className="processTop"/>
            </View>
            <Text className="processText">
              疯抢中
            </Text>
          </View>
          <Text x-if={btnText === '去使用'} className="toUseText">
            {getExpireTimeText()}
          </Text>
        </View>}
      </View>
    </View>;
}
export default memo(Coupon);
